
import { Component, Vue, PropSync, Prop, Watch } from 'vue-property-decorator';
import urlConfig from '@/Configurations/urlConfig';
import { getBase64 } from '@/utils/utils';
import i18n from '@/lang';

@Component({
  name: 'SharePage',
  components: {},
})
export default class SharePage extends Vue {
  @PropSync('show', { type: Boolean, default: true }) syncedShow!: boolean;
  //活动ID：activityId，课程ID：courseId，话题ID：topicId，资料ID：postId，文件ID:fileId,展示类型 :showType
  @Prop({ type: Object, default: () => ({ resourceId: '', activityId: '', courseId: '', topicId: '', postId: '', showType: '',type:'' }) }) readonly shareParams!: any; //分享参数
  private imgSrc: string = '';
  private imageLoadingStatus: boolean = false;
  get token() {
    return window.localStorage.getItem('token') || '';
  }
  @Watch('syncedShow')
  isShow(n:boolean,o:boolean){
    if (n) {
      this.filterData()
    }
  }
  created() {}
  filterData() {
    const httpRequestUrl:string = urlConfig.httpRequestUrl
    const showType = this.shareParams.showType

    if (showType == 'activity' && this.shareParams.activityId) { //研讨 文章 会议
      this.imgSrc = httpRequestUrl+'/share/activity?activity_id='+this.shareParams.activityId+'&token='+this.token
    }else if(showType == 'office' && this.shareParams.resourceId){//教研室
      this.imgSrc = httpRequestUrl+'/share/office?office_id='+this.shareParams.resourceId+'&token='+this.token
    }else if(showType == 'officeCourse' && this.shareParams.courseId){//教研室样板课程
      this.imgSrc = httpRequestUrl+'/share/officeCourse?course_id='+this.shareParams.courseId+'&token='+this.token
    }else if(showType == 'topic' && this.shareParams.topicId){//主题
      this.imgSrc = httpRequestUrl+'/share/topic?topic_id='+this.shareParams.topicId+'&token='+this.token
    }else if(showType == 'resource' && this.shareParams.postId){ //资源
      this.imgSrc = httpRequestUrl+'/share/resource?office_id='+this.shareParams.resourceId+'&post_id='+this.shareParams.postId+'&type='+this.shareParams.type+'&token='+this.token
    }else{
      this.imgSrc=''
    }
    // console.log(this.shareParams)
  }

  async doCopy() {
    const base64 = await getBase64(this.imgSrc);
    if(typeof base64 !== 'string') {
      this.$toast(i18n.t('Common.链接复制失败'));
      return
    }

    window.qrcode.decode(base64);
    window.qrcode.callback = (res: string) => {
      this.$copyText(res).then(() => {
        this.$toast(i18n.t('Common.链接复制成功'));
      }, () => {
        this.$toast(i18n.t('Common.链接复制失败'));
      })
    }
  }

  closeDialog() {
    this.syncedShow = false;
  }
}
